import React from 'react'

import { Gesture } from 'react-with-gesture'
import { utils } from 'gipsy-misc'

const PANEL_WIDTH = 500

export default ({ active, onClose, children }) => (
  <Gesture>
    {({ down, x, y, xDelta, yDelta, xInitial, yInitial }) => {
      let style = {}
      if (utils.device.isMobile()) {
        const distance = x - xInitial > 0 ? x - xInitial : 0
        if (down && active) {
          this.dragStarted = true
          style.right = -distance
        }

        /* close the panel if user dragged enough the panel */
        if (!down && this.dragStarted) {
          this.dragStarted = false
          if (distance > PANEL_WIDTH / 5 && !down && active) {
            setImmediate(onClose)
          }
        }
      }

      return children({ moving: !!down, style })
    }}
  </Gesture>
)



// WEBPACK FOOTER //
// ./src/features/taskPanel/components/gestureHandler.js